import React, { useMemo, useState } from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';
import { useDispatch, useSelector } from 'react-redux';
import MetisMenu from 'react-metismenu';
import { Link, Outlet } from 'react-router-dom';
import DefaultLink from './DefaultLink';
import Header from '../Shared/Header';
import Footer from '../Shared/Footer';
import { openLeftSidebarAction, openRightSidebarAction } from '../../actions/settingsAction';
import { universityMenu, adminMenu } from './metisMenu';
import { useTranslation } from 'react-i18next';
import { clearAuthData } from '@/pages/Authentication/store/authSlice';

const SidebarComponent = ({ roles }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { isToggleLeftBar, isMinSidebar, isMenuGrid } = useSelector((state) => state.settings);

    const [menuType, setMenuType] = useState(
        roles ? (roles[0].name === 'Admin' ? true : false) : false
    );

    const closeBar = () => {
        dispatch(openRightSidebarAction(false));
    };

    const toggleMenuType = (type) => setMenuType(type);

    const translatedUniversityMenu = useMemo(
        () =>
            universityMenu.map((item) => ({
                ...item,
                label: t(item.label), 
            })),
        [t]
    );

    const translatedAdminMenu = useMemo(
        () =>
            adminMenu.map((item) => ({
                ...item,
                label: t(item.label), 
            })),
        [t]
    );

    return (
        <div id="main_content">
            <div
                id="header_top"
                style={{background: "white"}}
                className={`header_top ${isMinSidebar ? 'dark' : ''}`}>
                <div className="container">
                    <div className="hleft">
                        <Link
                            to="/"
                            className="flex justify-center items-center">
                            <img
                                className="rounded-lg w-[50px] lg:w-full"
                                src={"/assets/images/logo_minize.png"}
                                alt={t('Sidebar_LogoAlt')}
                            />
                        </Link>
                        <div className="dropdown">
                            <span
                                onClick={() => dispatch(openLeftSidebarAction(!isToggleLeftBar))}
                                className="icon menu_toggle !text-[#0d356b] hover:!text-[#0d356b] text-xl cursor-pointer">
                                <i className="fe fe-align-center"></i>
                            </span>
                        </div>
                    </div>

                    <div className="hright">
                        <Link
                            to="/login"
                            onClick={() => dispatch(clearAuthData())}
                            className="icon settingbar !text-[#0d356b] hover:!text-[#0d356b] text-xl cursor-pointer">
                            <i className="fe fe-power"></i>
                        </Link>
                    </div>
                </div>
            </div>

            <div
                id="left-sidebar"
                className="sidebar h-[100vh]"
                style={{background: "white"}}
                >
                {/* <h5 className="brand-name !text-[#0d356b]">{t('Sidebar_BrandName')}</h5> */}

                {/* <ul className="nav nav-tabs">
                    {roles && (
                        <>
                            {roles[0].name === 'student' && (
                                <li className="nav-item">
                                    <span
                                        className={`nav-link ${!menuType ? ' active' : ''} !text-[#0d356b]`}
                                        onClick={() => toggleMenuType(false)}>
                                        {t('Sidebar_University')}
                                    </span>
                                </li>
                            )}
                            {roles[0].name === 'Admin' && (
                                <li className="nav-item ">
                                    <span
                                        className={`nav-link ${menuType ? ' active' : ''} !text-[#0d356b]`}
                                        onClick={() => toggleMenuType(true)}>
                                        {t('Sidebar_Admin')}
                                    </span>
                                </li>
                            )}
                        </>
                    )}
                </ul> */}

                <div className="tab-content">
                    <div
                        className={`tab-pane fade${!menuType ? ' show active' : ''}`}
                        id="menu-uni"
                        role="tabpanel">
                        <nav className="sidebar-nav overflow-hidden">
                            <MetisMenu
                                content={translatedUniversityMenu}
                                noBuiltInClassNames={true}
                                classNameContainer={isMenuGrid ? 'metismenu grid' : 'metismenu'}
                                classItemActive="active"
                                LinkComponent={(e) => <DefaultLink itemProps={e} />}
                            />
                        </nav>
                    </div>

                    <div
                        className={`tab-pane fade${menuType ? ' show active' : ''}`}
                        id="menu-admin"
                        role="tabpanel">
                        <nav className="sidebar-nav overflow-hidden">
                            <MetisMenu
                                content={translatedAdminMenu}
                                noBuiltInClassNames={true}
                                classNameContainer={isMenuGrid ? 'metismenu grid' : 'metismenu'}
                                classItemActive="active"
                                LinkComponent={(e) => <DefaultLink itemProps={e} />}
                            />
                        </nav>
                    </div>
                </div>
            </div>

            <div
                className="page"
                onClick={closeBar}>
                <Header />
                <Outlet />
                <Footer />
            </div>
        </div>
    );
};

SidebarComponent.displayName = 'Sidebar';

const Sidebar = (props) => {
    return (
        <ErrorWrapper>
            <SidebarComponent
                data-id="Sidebar-cpn"
                {...props}
            />
        </ErrorWrapper>
    );
};

export default Sidebar;
